import { Configuration, LogLevel, RedirectRequest } from '@azure/msal-browser';
import { Constants } from '../common/Constants';
import * as Scopes from '../common/Scopes';
import { isInShell } from '../common/Shell';

/**
 * Configuration object to be passed to MSAL instance on creation
 */
export const getRedirectUri = (): string => {
  let redirectUri = globalThis.location.origin;
  if (isInShell()) {
    redirectUri += '/app/documents';
  }
  return redirectUri
}

export const msalConfig: Configuration = {
    auth: {
        clientId: Constants.AZURE_CLIENT_ID || '',
        authority: Constants.AUTH_AUTHORITY,
        redirectUri: getRedirectUri(),
        postLogoutRedirectUri: globalThis.location.origin,
        navigateToLoginRequestUrl: true,
    },
    cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: false,
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                      console.error(message);
                      return; 
                    case LogLevel.Warning:
                      console.warn(message);
                      return;
                    case LogLevel.Info:
                      console.info(message);
                      return;
                    case LogLevel.Verbose:
                      console.debug(message);
                      return;
                }
              },
              logLevel: process.env.NODE_ENV === 'production' ? LogLevel.Warning : LogLevel.Verbose,
              piiLoggingEnabled: true,
            },
        allowNativeBroker: false,
        allowRedirectInIframe: true,
    },
};

/**
 * Scopes for login request
 */
export const loginRequest: RedirectRequest = {
    scopes: Scopes.GRAPH_SCOPES,
    prompt: 'select_account',
};

/**
 * Scopes for token request
 */
export const tokenRequest = {
    scopes: Scopes.GRAPH_SCOPES,
};
